import React, { useState } from 'react'
import { Container, HeaderWrapper, ImageAvatar } from './styles'

import { RootState } from '../../store/modules/rootReducer'
import { useSelector } from 'react-redux'

import { BiCamera } from 'react-icons/bi'
import ModalImageStudent from '../ModalImageStudent'
import AvatarPerson from '../../assets/player/avatar-person.svg'
const ImageStudent: React.FC = () => {
  const { profile } = useSelector((state: RootState) => state.student)

  const [openModal, setOpenModal] = useState<boolean>(false)

  return (
    <Container>
      <HeaderWrapper>
        <ImageAvatar>
          <img
            src={profile.avatar || AvatarPerson}
            alt={profile.name}
            style={{ objectFit: 'cover' }}
          />
          <BiCamera
            size={30}
            onClick={() => {
              setOpenModal(true)
            }}
          />
          <ModalImageStudent onClose={() => setOpenModal(false)} open={openModal} />
        </ImageAvatar>
      </HeaderWrapper>
    </Container>
  )
}

export default ImageStudent
